import { motion } from "framer-motion";
import { Check } from "lucide-react";

const deliverables = [
  "La plataforma estratégica de la marca: qué es, qué promete y a quién.",
  "El posicionamiento para tus dos públicos: el que come y el que invierte.",
  "La esencia y la personalidad de Mamma Pasta —tradición casera, calidad gourmet.",
  "El mapa de arquitectura: cómo conviven fábrica, franquicia, local y distribución.",
  "El relato de origen —el legado de tu vieja— listo para contarse.",
];

const MammaSistema = () => {
  return (
    <section
      id="sistema"
      className="py-24 md:py-32 relative overflow-hidden"
      style={{
        background: "linear-gradient(180deg, hsl(215 48% 14%), hsl(217 61% 10%))",
      }}
    >
      <div className="container px-4 max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-10"
        >
          <span
            className="text-xs md:text-sm font-semibold tracking-[0.25em] uppercase mb-5 block"
            style={{ color: "#7ab7fd" }}
          >
            El camino
          </span>
          <h2 className="font-display text-3xl md:text-5xl font-bold text-white leading-[1.1] mb-6">
            Un sistema,
            <br />
            <span style={{ color: "#7ab7fd" }}>en dos capas.</span>
          </h2>
          <p className="italic text-base md:text-lg text-white/60 leading-relaxed max-w-2xl mx-auto">
            No es un catálogo de servicios sueltos. Es un solo sistema que se
            construye por capas: primero el cimiento que vuelve vendible la marca,
            después su expresión completa.
          </p>
        </motion.div>

        {/* Capa 1 */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="rounded-2xl border border-white/10 p-7 md:p-9 mb-6"
          style={{ background: "rgba(122,183,253,0.06)" }}
        >
          <p className="text-[11px] uppercase tracking-[0.25em] text-white/50 mb-3">
            Capa 1 · se entrega primero
          </p>
          <h3 className="font-display text-2xl md:text-3xl font-bold text-white mb-2">
            La Plataforma Estratégica
          </h3>
          <p className="text-sm mb-6" style={{ color: "#7ab7fd" }}>
            El cimiento · el Ser
          </p>
          <p className="text-base text-white/75 leading-relaxed mb-6">
            Definimos qué es Mamma Pasta de verdad —su origen, su legado, lo que la
            hace elegible— y lo convertimos en un sistema transferible. Acá también
            ordenamos tus frentes para que crezcan sin pisarse.
          </p>
          <ul className="space-y-3 mb-6">
            {deliverables.map((d) => (
              <li key={d} className="flex items-start gap-3">
                <span
                  className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center"
                  style={{ background: "#7ab7fd" }}
                >
                  <Check className="w-3 h-3 text-[#0a162a]" strokeWidth={3} />
                </span>
                <span className="text-sm md:text-base text-white/85 leading-relaxed">
                  {d}
                </span>
              </li>
            ))}
          </ul>
          <p
            className="font-display italic text-lg md:text-xl"
            style={{ color: "#7ab7fd" }}
          >
            Esto es lo que vuelve vendible la franquicia.
          </p>
        </motion.div>

        {/* Capa 2 */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.25 }}
          className="rounded-2xl border border-white/10 p-7 md:p-9"
          style={{ background: "rgba(255,255,255,0.02)" }}
        >
          <p className="text-[11px] uppercase tracking-[0.25em] text-white/50 mb-3">
            Capa 2 · al aprobar la primera
          </p>
          <h3 className="font-display text-2xl md:text-3xl font-bold text-white mb-2">
            Identidad y Activación
          </h3>
          <p className="text-sm mb-6" style={{ color: "#8b87f5" }}>
            La expresión · el Hacer
          </p>
          <p className="text-base text-white/75 leading-relaxed mb-6">
            Con el cimiento definido, evolucionamos la identidad visual y verbal sin
            perder lo que ya reconocen de vos, construimos la narrativa completa y
            la activamos donde importa: el local, el packaging, las redes y el
            material que un inversor ve antes de firmar.
          </p>
          <span className="inline-block text-xs uppercase tracking-[0.2em] text-white/45 border border-white/10 rounded-full px-4 py-2">
            Se detalla al cerrar la primera capa
          </span>
        </motion.div>
      </div>
    </section>
  );
};

export default MammaSistema;
